"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingConsent = void 0;
exports.createTrackingConsentState = createTrackingConsentState;
const observable_1 = require("../tools/observable");
exports.TrackingConsent = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted',
};
function createTrackingConsentState(currentConsent) {
    const observable = new observable_1.Observable();
    return {
        tryToInit(trackingConsent) {
            if (!currentConsent) {
                currentConsent = trackingConsent;
            }
        },
        update(trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted() {
            return currentConsent === exports.TrackingConsent.GRANTED;
        },
        observable,
    };
}
//# sourceMappingURL=trackingConsent.js.map